<template>
  <div>
    <div class="shrink" v-if="!isEnlarge">
      <img alt="" src="../../images/enlarge.png" @click="changeEnlarge"/>
    </div>
    <div class="legendBox" v-else>
      <div>
        <div class="top">
          <span style="margin-left: 2rem">图例</span>
          <Icon type="md-qr-scanner" class="icon" @click="changeEnlarge"/>
        </div>
        <div class="content">
          <div>
            <img src="../../images/mapIcon/shexiang1.png" alt="" class="img"/>
            <span class="title">视频监控</span>
          </div>
          <div>
            <img src="../../images/mapIcon/duiwu1.png" alt="" class="img"/>
            <span class="title">应急队伍</span>
          </div>
          <div>
            <img src="../../images/mapIcon/cangku.png" alt="" class="img"/>
            <span class="title">应急库</span>
          </div>
          <div>
            <img src="../../images/mapIcon/yujing1.png" alt="" class="img"/>
            <span class="title">事件预警</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Legend",
  data() {
    return {
      isEnlarge: true
    }
  },
  methods: {
    changeEnlarge() {
      this.isEnlarge = !this.isEnlarge
    }
  }
}
</script>

<style scoped lang="less">
@import "Legend.less";
</style>
